import AppSidebar from "./AppSidebar";
import { ConfigProvider, Drawer, Grid, Layout, theme } from "antd";
import { useEffect, useState } from "react";
import AppHeader from "./AppHeader";
import './index.scss';
import AppPage from "./AppPage";
import { configDark, configLight } from "../constants/theme";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from "../page/auth/Login";
import AuthRoutes from "../page/auth/AuthRoutes";
import utc from 'dayjs/plugin/utc';
import dayjs from "dayjs";
import ruRU from "antd/es/locale/ru_RU";

dayjs.extend(utc);
dayjs.locale('ru');

const AppLayout = () => {
    const { systemMode } = useSelector((state) => state.theme);
    const { data: { isAuthenticated } } = useSelector((state) => state.auth);
    const location = useLocation();

    const { defaultAlgorithm, darkAlgorithm } = theme;

    const hideSidebar = location.pathname.includes('/test');
    const screens = Grid.useBreakpoint();
    // `md` is undefined until the first measurement, so only `false` means a phone.
    const isMobile = screens.md === false;
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Close the drawer on navigation and when the viewport grows to desktop.
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname, isMobile]);

    return (
        <ConfigProvider
            locale={ruRU}
            theme={{
                algorithm: systemMode === 'dark' ? darkAlgorithm : defaultAlgorithm,
                token: systemMode === 'dark' ? configDark : configLight,
            }}
        >
            <AuthRoutes>
                {!isAuthenticated ? (
                    <Routes>
                        <Route path="/login" element={<Login />} />
                    </Routes>
                ) : (
                    <Layout className={'app-root'}>
                        <AppHeader
                            showMenuButton={isMobile && !hideSidebar}
                            onMenuClick={() => setMobileMenuOpen(true)}
                        />
                        <Layout className={'app-body'}>
                            {!hideSidebar && !isMobile && <AppSidebar />}
                            {!hideSidebar && isMobile && (
                                <Drawer
                                    placement="left"
                                    width="min(280px, 85vw)"
                                    open={mobileMenuOpen}
                                    onClose={() => setMobileMenuOpen(false)}
                                    closable={false}
                                    styles={{ body: { padding: 0 } }}
                                >
                                    <AppSidebar inDrawer onNavigate={() => setMobileMenuOpen(false)} />
                                </Drawer>
                            )}
                            <Layout className={'ant--page'}>
                                <AppPage />
                            </Layout>
                        </Layout>
                    </Layout>
                )}
            </AuthRoutes>
        </ConfigProvider>
    );
};

export default AppLayout;